(function($) {

$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null){
       return null;
    }
    else{
       return results[1] || 0;
    }
}

    if ($.urlParam('customer_posted') == 'true' || $.urlParam('customer_posted') !== '' ) {

        $('.cb-countdown-timer').each(function(){
         var sectionHeight = $(this).find('.banner').outerHeight();
          var messageHeight = $(this).find('.alert').outerHeight();
         
          $(this).find('.banner').height(sectionHeight + messageHeight);
        })    
    }
   var video = $('.cb-video-modal .video-hero').find('video');
     function stopVideo(){
          video.trigger('pause');
     }

    function playVideo(){
          video.trigger('play');
     }
  
  $('#cb-btn-video').on('click', function() {
       stopVideo();

  })
  $('#cb-video-modal .overlay,#cb-video-modal .button--close').on('click', function() {
       playVideo();

  })
// feature-image-2 
    $('.cb-overview-container #cb--theme').on('change',function(){

      if($(this).is(':checked')) {

        $(this).parents('.cb-overview-container').find('.feature-image-1').css('opacity', 0);
         $(this).parents('.cb-overview-container').find('.feature-image-2').css('opacity', 1);
      } else {

        $(this).parents('.cb-overview-container').find('.feature-image-1').css('opacity', 1);
         $(this).parents('.cb-overview-container').find('.feature-image-2').css('opacity', 0);
      }
    });
  
    $('.cb-options-slider .multicolumn').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      // autoPlay: 2000,
      autoPlay: false,
      pauseAutoPlayOnHover: true
    });
    $('.hint-description').appendTo('body')
  
   $('.hint-block .hint').on({
    mouseenter: function () {
      var dataHint = $(this).data('hint');
      var mouseX = 0, mouseY = 0;
      var xp = 0, yp = 0;
     
        $(this).mousemove(function(e){
          mouseX = e.pageX ;
          mouseY = e.pageY ; 

         $('.hint-description').each(function(){
            if ($(this).data('hint-desc') == dataHint) {
              
               $(this).addClass('hint-hovered');
              if ($(this).hasClass('hint-hovered')) {
      
              
        
                $(this).css({
                top: mouseY + 20 +'px',
                left: mouseX - $(this).outerWidth() + 30 + 'px'
                })
                 var pos = $(this).position(),
                     posX = pos.left;
                
                 console.log(posX);
                if (posX < 0 || posX == 15 ) {
                  $(this).css('left', '15px');
               }
            } else {
                $(this).removeClass('hint-hovered');
              }
            }
          })
        });
      
      
    },
    mouseleave: function () {
      $('.hint-description').removeClass('hint-hovered');
    }
});

  $('.cb-show-more').on('click',function(){
    var parent =  $(this).parents('.cb-text-more');
    if (!parent.hasClass('active')) {
      parent.find('.cb-more-content').slideDown();
      parent.addClass('active');
      parent.find('.cb-more').hide();
      parent.find('.cb-less').show();
    } else {
      parent.find('.cb-more-content').slideUp();
      parent.removeClass('active');
      parent.find('.cb-more').show();
      parent.find('.cb-less').hide();
    }
  })


  $.fn.visible = function(partial) {
	var $t            = $(this),
	    $w            = $(window),
	    viewTop       = $w.scrollTop(),
	    viewBottom    = viewTop + $w.height(),
	    _top          = $t.offset().top,
	    _bottom       = _top + $t.height(),
	    compareTop    = partial === true ? _bottom : _top,
	    compareBottom = partial === true ? _top : _bottom;
      
	return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
};
$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();
      
	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();
      
	return elementBottom > viewportTop && elementTop < viewportBottom;
};
      
function scrollAnimaitons(target, data_smooth, transitionTime, animationType, delay, rotate) {
	var element = $(target);

	if (transitionTime == 'undefined') {
		transitionTime = 0;
	}
	if (animationType == 'undefined') {
		animationType = 'ease';
	}

	element.each(function (i, el) {

		//General Styles
		$(el).css({
			"transition": "all "+ transitionTime + "s " + animationType,
			"-webkit-transition": "all "+ transitionTime + "s " + animationType,
			"-moz-transition": "all "+ transitionTime + "s " + animationType,
			"transition-delay": delay + "s",
			"-webkit-transition-delay": delay + "s",
			"-moz-transition-delay": delay + "s"
		})
		var move = $(el);
		var lastScrollTop = 0;
		$(window).scroll(function (event) {
          
			var st = $(this).scrollTop();
			if (!rotate) {
				var top =  move.offset().top - $(this).scrollTop();
			
				if (move.visible(true)) {

					move.addClass("moving-target").css({
						"transform": "translateY(" + top / data_smooth + "px)",
						"-webkit-transform": "translateY(" + top / data_smooth + "px)",
						"-moz-transform": "translateY(" + top / data_smooth + "px)"
					});

				} else {
					move.removeClass("moving-target");
				}
			} else {
				if (move.visible(true)) {

					move.addClass("moving-target");
					if (st > lastScrollTop){
						move.css({
							"transform": "rotate(" +  (data_smooth++)/3 + "deg)",
							"-webkit-transform": "rotate(" + (data_smooth++)/3 + "deg)",
							"-moz-transform": "rotate(" + (data_smooth++)/3 + "deg)"
						});
					} else {
						move.css({
							"transform": "rotate(" + (data_smooth--)/3 + "deg)",
							"-webkit-transform": "rotate(" + (data_smooth--)/3 + "deg)",
							"-moz-transform": "rotate(" + (data_smooth--)/3 + "deg)"
						});
					}
					lastScrollTop = st;


				} else {
					move.removeClass("moving-target");
				}
			}
		

		});
	});
}
  // scrollAnimaitons($('.cb-fixed-img img'), 13);
  // parallaxEffect($('.cb-fixed-img img'),3)
    $(document).ready(function() {
      
          $('a[href^="#"]').click(function (event) {
          event.preventDefault();
          var targetId = $(this).attr('href'); 
          var targetElement = $(targetId); 
  
          if (targetElement.length) {

              $('html, body').animate({
                  scrollTop: targetElement.offset().top
              }, 800);
          } else {
    
              window.location.href = "/" + targetId;
          }
      });

      
    //   $('a[href^="#"]').click(function(event) {
    //     event.preventDefault(); // Заборона стандартного переходу по посиланню

    //     var targetId = $(this).attr('href'); // Отримуємо значення href (наприклад, "#id1")
    //     var targetElement = $(targetId); // Шукаємо елемент з таким ID
    //     var currentPath = window.location.pathname; // Отримуємо шлях (без домену)


    //     // Перевіряємо, чи сторінка знаходиться в німецькій версії (/de, /de/, /de/pages/ і т.д.)
    //     var isGermanVersion = currentPath.startsWith("/de");

    //     if (targetElement.length) {
    //         // Якщо елемент існує, плавно прокручуємо до нього
    //         $('html, body').animate({
    //             scrollTop: targetElement.offset().top
    //         }, 800);
    //     } else if (isGermanVersion) {
    //         // Якщо це німецька версія, оновлюємо URL без перезавантаження та пробуємо скролити
    //         // history.pushState(null, null, targetId);

          
    //         setTimeout(function() {
    //             var newTarget = $(targetId);
    //             if (newTarget.length) {
    //                 $('html, body').animate({
    //                     scrollTop: newTarget.offset().top
    //                 }, 800);
    //             }
    //         }, 100);
    //     } else {
    //         // Якщо не в німецькій версії, переходимо на головну та додаємо хеш у URL
    //         window.location.href = "/" + targetId;
    //     }
    // });

      
     var CBcurrentPath = window.location.pathname; // Отримуємо шлях (без домену);
    var CBisGermanVersion = CBcurrentPath.startsWith("/de");
   var CBanchorTraget =  $('a[href^="#"]');
      
      if (CBisGermanVersion) {
        CBanchorTraget =  $('a[href^="/de#"]') 
      } 
           CBanchorTraget.click(function (event) {
              console.log('GERMAN CLICK')
              event.preventDefault(); // Заборона стандартного переходу по посиланню
              var getID = $(this).attr('href').split('#'); // Отримуємо значення href (наприклад, "#id1")
             var targetId = getID[1]
              var targetElement = $('#'+targetId); // Шукаємо елемент з таким ID
                console.log(getID)
        
              if (targetElement.length) {
                  // Якщо елемент існує, плавно прокручуємо до нього
                  $('html, body').animate({
                      scrollTop: targetElement.offset().top
                  }, 800);
              } else {
                  // Якщо елемента немає, переходимо на головну і додаємо хеш у URL
                  window.location.href = "/" + targetId;
              }
          });
               

      if (window.matchMedia("(max-width: 700px)").matches) {
        $('.cb-timeline .indicators').appendTo($('.cb-timeline slider-element'))
      }




      
    });
})(jQuery);


$(document).ready(function () {
   $('#cb-product-modal').on('click', function () {
    window.history.back();
     console.log( window.history) 
  });
// $(".cb-video-section").find('video').attr('id','fake-video')
  
  //   const $cbVideo = $(".cb-video-section").find('video');
  //  $cbVideo.clone().attr('id','fake-video').insertAfter($(".cb-video-section").find('video'));
  // const $realVideo =  $(".cb-video-section").find('video:first');
  // const $fakeVideo = $(".cb-video-section").find('#fake-video');

  // $fakeVideo.removeAttr('controls');
  
  // console.log('VIDEO1',$realVideo);
  // console.log('VIDEO2',$fakeVideo);


  

  //   $fakeVideo.on("click", function () {
  //       $fakeVideo.hide();
  //       $realVideo.show();
  //       // $realVideo.play();
  //   });


    // const observer = new IntersectionObserver((entries) => {
    //     entries.forEach(entry => {
    //         if (!entry.isIntersecting) {
    //             $realVideo.hide();
    //             $fakeVideo.show();
    //             $realVideo.pause();
    //             $realVideo.currentTime = 0; 
    //         }
    //     });
    // }, { threshold: 0.3 });

    // observer.observe($realVideo);



   // const $video = $(".cb-video-section").find('video');
   //  let interacted = false;

    // $video.removeAttr("controls");


    // const observer = new IntersectionObserver((entries) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting && !interacted) {
    //             $video.removeAttr("controls");
    //         }
    //     });
    // }, { threshold: 0.5 });

    // observer.observe($video[0]);


    // $video.on("click", function () {
    //    $(this).attr("controls", "true");
    //     if (!interacted) {
    //         interacted = true;
           
    //     }
    // });
});